import React from 'react'

class EditPen extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
          <g fill="#FFF" fillRule="nonzero">
            <g>
              <g>
                <path
                  d="M19.388 19.447v1.513H1.46v-1.513h17.928zM14.877 1.04l5.65 5.65-3.567 3.566-.01-.009-7.438 7.44-6.384.749.75-6.384 7.438-7.439-.006-.006 3.567-3.567zm-2.504 4.629L5.31 12.733l-.468 3.99 3.99-.47 7.062-7.062-3.521-3.522zm2.493-2.5L13.49 4.545l3.531 3.531L18.397 6.7l-3.531-3.53z"
                  transform="translate(-720.000000, -231.000000) translate(622.000000, 230.000000) translate(98.000000, 1.000000)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default EditPen
